import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';

export interface PageTitleProps {
  title: ReactNode;
  subtitle: ReactNode;
}

const Title = styled.div`
  ${typography.sm.regular}
`;

const Subtitle = styled.div`
  ${typography.lg.regular}
  margin-top: ${globalTheme.spacing.xxs}
`;

export const PageTitle: FC<React.PropsWithChildren<PageTitleProps>> = ({ title, subtitle }) => (
  <div>
    <Title>{title}</Title>
    <Subtitle>{subtitle}</Subtitle>
  </div>
);
